import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { Card as CardBase } from '@chilecompra/react-kit/components'

export const Root = styled(ContainerBase)`
  &.MuiContainer-root {
    margin: 35px auto 0;
    width: 100%;
  }
`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  line-height: 32px;
  margin: 0;
  padding: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
`

export const Card = styled(CardBase)`
  &.MuiPaper-root > div {
    min-height: 86px;
    position: relative;
  }
`

export const CardIndicator = styled('div')`
  background-color: ${props => props.theme.palette.brand.white};
  color: ${props => props.theme.palette.brand.primary};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: 700;
  left: 10px;
  line-height: 21px;
  padding: 4px 20px;
  position: absolute;
  top: -15px;
`

export const Info = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  text-align: right;
`

export const Italic = styled('span')`
  font-style: italic;
`

export const Strong = styled('strong')``
